<template>
  <div class="edit-video-box">
    <el-dialog :title="'评论查看'" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-input type="textarea" :rows="4" v-model="comment" disabled>
      </el-input>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      comment: "",
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.comment = "";
    },
    open(content) {
      this.dialogVisible = true;
      this.comment = content
    }
  }

}
</script>

